<template>
  <CModal
    :show.sync="isOpen"
    size="xl"
    @close="close"
  >
    <template #header>
      <h5 class="modal-title">
        <CIcon name="cipImage" class="mr-2"/>
        <span v-if="media && media.file_name">{{ media.file_name }}</span>
        <span v-if="media && media.id" class="ml-3 text-muted font-weight-normal">
          [ID {{ media.id }}]
        </span>
        <span v-if="media && media.photographer_email" class="ml-3 text-muted font-weight-normal">
          <CIcon name="cipPhotographer" size="custom-size" :height="18" class="mr-1"/>
          {{ media.photographer_email }}
        </span>
      </h5>
    </template>

    <div v-if="media" class="image-container">
      <img
        :src="media.original || media.sd || media.thumb"
        :alt="`Photo ${media.id}`"
        @error="onImageError"
        class="modal-preview-image"
      />
    </div>

    <div v-else class="text-center py-5">
      <CIcon name="cipImage" size="3xl" class="text-secondary mb-3"/>
      <p class="text-muted">
        <translate translate-context="edge-orders.zoom">No image to display</translate>
      </p>
    </div>

    <template #footer>
      <CButton color="secondary" @click="close">
        <translate translate-context="edge-orders.zoom">Close</translate>
      </CButton>
      <CButton
        v-if="media && (media.original || media.sd)"
        color="primary"
        @click="downloadMedia"
      >
        <translate translate-context="edge-orders.zoom">Download</translate>
        <CIcon name="cipDownload" size="custom-size" :width="16" class="ml-1"/>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { mapGetters } from 'vuex'
import Downloader from '@/domain/core/utils/downloader'

export default {
  name: 'MediaZoomModal',
  data() {
    return {
      isOpen: false,
      media: null
    }
  },
  methods: {
    open(media) {
      this.media = media
      this.isOpen = true
    },
    close() {
      this.isOpen = false
      this.media = null
    },
    onImageError(event) {
      // Fallback chain: original -> sd -> thumb -> placeholder
      if (this.media && this.media.original && event.target.src === this.media.original) {
        event.target.src = this.media.sd || this.media.thumb
      } else if (this.media && this.media.sd && event.target.src === this.media.sd) {
        event.target.src = this.media.thumb
      } else {
        event.target.src = '/img/placeholder-image.png'
      }
    },
    downloadMedia() {
      const fullResUrl = this.media?.original || this.media?.sd
      if (fullResUrl) {
        const fileName = this.media?.file_name || `media-${this.media?.id}`
        Downloader.downloadFromUrl(fullResUrl, fileName)
      }
    }
  }
}
</script>

<style scoped>
/* Styles are in src/assets/scss/components/modals.scss */
/* .image-container and .modal-preview-image classes */
</style>